/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Harden_Detail6Inputs */

const en_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate limits, ban-safe sending and handoff before launch.`)
};

const ar_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدود الإرسال وإرسال آمن من الحظر والتسليم قبل الإطلاق.`)
};

const bn_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেট লিমিট, ব্যান-নিরাপদ পাঠানো আর লঞ্চের আগে হস্তান্তর।`)
};

const de_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratenlimits, sperrsicheres Senden und Übergabe vor dem Start.`)
};

const es_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límites de envío, envío seguro contra bloqueos y derivación antes del lanzamiento.`)
};

const fr_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites d'envoi, envoi anti-bannissement et relais avant le lancement.`)
};

const pt_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites de envio, envio seguro contra bloqueios e passagem antes do lançamento.`)
};

const zh_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送限流、防封策略，上线前完成人工交接。`)
};

const tr_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderim limitleri, bana dayanıklı gönderim ve lansman öncesi devir.`)
};

const ru_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лимиты отправки, антибан-отправка и передача перед запуском.`)
};

const pl_svc_messaging_bots_harden_detail6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limity wysyłki, wysyłka odporna na bany i przekazanie przed startem.`)
};

/**
* | output |
* | --- |
* | "Rate limits, ban-safe sending and handoff before launch." |
*
* @param {Svc_Messaging_Bots_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_harden_detail6 = /** @type {((inputs?: Svc_Messaging_Bots_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_harden_detail6(inputs)
	if (locale === "de") return de_svc_messaging_bots_harden_detail6(inputs)
	if (locale === "es") return es_svc_messaging_bots_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_harden_detail6(inputs)
	return en_svc_messaging_bots_harden_detail6(inputs)
});
export { svc_messaging_bots_harden_detail6 as "svc_messaging-bots_HARDEN_detail" }